import { Box, Typography } from "@material-ui/core";
import { styled } from "@mui/material";
import React from "react";

import { MemoizedButton } from "../../../SDK/button";
import { imagesList } from "../../../constants";

//import MemoizedButton from "../../../SDK/button";

const CustomCareer = styled(Box)(({ theme }) => ({
  ".career": {
    position: "relative",
    background: `url(${imagesList.aboutUsCareerBanner})`,
    height: "600px",
    ".power-career-box": {
      background: "rgba(255, 255, 255, 0.9)",
      width: "35%",
      position: "absolute",
      bottom: "0",
      borderRadius: "10px",
      padding: "31px 4% 10px 42px",
      left: "10%",
      ".heading": {
        fontSize: "22px",
        lineHeight: "36px",
        fontWeight: "700",
        marginBottom: "10px",
      },
      ".description": {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "400",
        marginBottom: "20px",
      },
      button: {
        width: "100%",
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    ".career": {
      height: "200px",
      ".power-career-box": {
        width: "90%",
        padding: "18px 4% 10px 18px",
        left: "16px",
        ".heading": {
          fontSize: "16px",
          lineHeight: "18px",
          marginBottom: "10px",
        },
        ".description": {
          fontSize: "12px",
          lineHeight: "16px",
        },
        button: {
          fontSize: "16px",
          width: "50%",
        },
      },
    },
  },
}));

const Career = () => {
  return (
    <CustomCareer>
      <Box className="career">
        <Box className="power-career-box">
          <Typography variant="h2" className="heading">
            Power your career
          </Typography>
          <Typography className="description">
            Ready to transform the future of transportation? Join a team that
            will have a huge impact on the future of our cities, everyday.
          </Typography>
          <MemoizedButton
            content={"Join us"}
            href={"https://turno.skillate.com/"}
          />
        </Box>
      </Box>
    </CustomCareer>
  );
};
export default Career;
